<template>
    <div>
        <mc-rich-text-editor
            ref="richTextEditorRef"
            :value="innerValue"
            style="min-height: 300px; max-width:99%"
            :upload-config="{
                maxFileSize: 5
            }"
            :menubar="menubar"
            :readonly="disabled"
            @change="handleChange"
        />
    </div>
</template>

<script>
import { computed, ref, getCurrentInstance } from '@vue/composition-api';

const menubar = Object.freeze([
    { type: 'history' },
    { type: 'clearFormat' },
    { type: 'strong' },
    { type: 'bullet_list' },
]);

export default {
    props: {
        value: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },

    setup(props) {
        const { proxy } = getCurrentInstance();
        const visible = ref(false);
        const buyerRecommendation = ref('');
        const innerValue = computed(() => props.value);

        const handleChange = (val) => {
            proxy.$emit('input', val);
        };

        // 关闭
        const handleClose = () => {
            visible.value = false;
        };

        return {
            menubar,

            innerValue,
            buyerRecommendation,
            handleClose,
            handleChange,
        };
    },
};
</script>

<style lang="scss" scoped>
::v-deep .mc-rich--text--editor {
    min-height: 150px !important;
}
</style>
